/**
 * Fontes do design system BYX: Space Grotesk para display/UI (títulos,
 * botões, labels, overlines), Open Sans para texto corrido — mesmos
 * pesos usados no protótipo (SG 400/500/700, OS 400/600/700) — e
 * JetBrains Mono (400/500) para tags, paths e ids. Todas empacotadas via
 * @fontsource, sem CDN (SR-09).
 */
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

export const openSans = "'Open Sans', system-ui, sans-serif";
export const spaceGrotesk = `'Space Grotesk', ${openSans}`;
export const jetbrainsMono =
  "'JetBrains Mono', ui-monospace, Menlo, Consolas, monospace";
